"use client";
import { notFound } from 'next/navigation';
import style from '@/assets/styling/scss/storypage.module.scss';
import { ScrollToTop, GoBack, StoryContent } from '@/components/elements';
import { NavBar, Footer } from '@/components/partials';
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {paperVariants} from '@/assets/utils/motion';

interface Story {
  id: string;
  information: object;
  image: object;
  gallery: object;
  partner: object;
}

const StoryPage = ({ id }: { id: string }) => {
  const [story, setStory] = useState<Story | null>(null);

  useEffect(() => {
    async function loadStory() {
      try {
        const response = await fetch('/data/stories.json');
        const data = await response.json();
        const storyData = data[id];
        if (!storyData) {
          notFound();
        } else {
          setStory(storyData);
        }
      } catch (error) {
        console.error('Error loading story:', error);
        notFound();
      }
    }
    loadStory();
  }, [id]);

  if (story === null) return null;

  return (
    <>
      <ScrollToTop />
      <NavBar />
      <main>
        <motion.section 
          className={style.content} 
          variants={paperVariants}
          initial="hidden"
          animate={["visible", "scale", "translateY"]}
          exit="exit"
        >
          <GoBack />
          {story && <StoryContent {...story} />}
        </motion.section>
      </main>
      <Footer />
    </>
  );
};

export default StoryPage;
